import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { PostComponent } from './post/post.component';
import { PostsComponent } from './posts/posts.component';

@NgModule({
  imports: [
    RouterModule,
    SharedModule,
  ],

  declarations: [
    PostComponent,
    PostsComponent,
  ],
})
export class BlogModule {
}



// WEBPACK FOOTER //
// ./src/app/blog/blog.module.ts